<template>
  <div class="app-page-container ">
    <div class="app-body">
      <h1 class="title">{{ $t("beforeDel.title") }}</h1>
      <!-- <p class="desc" >Upon submitting your deletion request, your game account and gameplay will be immediately suspended.<br><br>Once your deletion request has been completed, we cannot reverse it. All your game progress will be lost, including any virtual currency or items that you've earned or purchased. We will no longer be able to assist you with refunds or other pending Customer Service requests related to this game.<br><br>If you wish to block payments on your existing account or suspend play on your account, instead of deleting it, contact <a href="mailto:privacy@zynga.com">privacy@zynga.com</a>.<br><br>Please note that deleting this game account will not cancel active subscriptions. Subscriptions must be cancelled through the subscription provider (Apple, Google, Facebook, etc.).<br><br>Deleting your account does not prohibit you from creating a new account and starting fresh in the game.</p> -->
     
      <div class="step-bar-bg">
         <p class="desc">
        {{ $t("beforeDel.p1-1") }}
        <strong> {{ $t("beforeDel.p1-2") }} </strong>{{ $t("common.point") }}
        </p>
        <p class="desc">
          {{ $t("beforeDel.p2-1") }}
          <a v-omnisdk_open href="https://www.mattel163.com/privacypolicy.html" target="_blank"
            >www.mattel163.com/privacypolicy.html</a
          >{{ $t("common.point") }} {{ $t("beforeDel.p2-2") }}
        </p>
        <p class="desc">
          {{ $t("beforeDel.p3") }}
          <!-- <a v-omnisdk_open :href="mail">{{$store.state.serviceMail}}</a> {{ $t("common.point") }} -->
        </p>
        <p class="desc">
          {{ $t("beforeDel.p4") }}
        </p>

      </div>
      
      <!-- <div _ngcontent-c6="" class="form-check section"><label _ngcontent-c6="" class="form-check-label"><span _ngcontent-c6="" class="check-box btn form-check-input fa btn-success fa-check"></span><input _ngcontent-c6="" class="form-check-input ng-untouched ng-valid ng-dirty" type="checkbox" value="" hidden=""><span _ngcontent-c6="">I want to delete this game account. I understand that I will lose all game progress and accumulated virtual items in this game and that once my deletion request has been completed, it cannot be undone.</span></label></div> -->
      <div class="form-check-label" @click="toggleClick">
        <span
          class="check-box"
          :class="{ active: checkFlag,shake:shakeFlag}"
          ><i class="fa fa-check" v-show="checkFlag"></i
        ></span>
        <span class="check-label">
           {{ $t("beforeDel.p5") }}
        </span>
      </div>
      <div class="btn-for-vertical">
      <button
        class="game-button primary"
        @click="continueFun"
      >
        {{ $t("common.continue") }}
      </button>
      <button class="game-button default" @click="backToHome">
        {{ $t("common.cancel") }}
      </button>
      </div>
    </div>
    <description></description>
    <footerBar :activeIndex="1" @showLanguage="showLanguage"></footerBar>
  </div>
</template>
<script>
import footerBar from "../components/common/footer";
import description from "../components/common/description";
import {  Toast } from "mint-ui";

export default {
  data() {
    return {
      //   flag: 0,
      checkFlag: false,
      shakeFlag: false,
    };
  },
  components: {
    footerBar,
    description,
  },
  computed:{
    mail(){
      return 'mailto:' + this.$store.state.serviceMail;
    }
  },
  methods: {
    // toggle(index) {
    //   this.flag = this.flag === index ? 0 : index;
    // },
    continueFun(){
      if(!this.checkFlag){

         this.shakeFlag =true
            Toast({
              message: this.$t("toast.checkTip"),  // 请勾选
            });

            setTimeout(() => {
              this.shakeFlag =false
            }, 1000);
            return
      }else{
              this.$router.push('./DelOperation')

      }

    },
      showLanguage(){
      this.$emit('showLanguage')
    },
    toggleClick() {
      this.checkFlag = !this.checkFlag;
    },
    backToHome() {
      this.$router.push("./Home");
    },
  },
};
</script>
<style lang="less" scoped>
p{
  margin-bottom: 0.34rem;
}
.title {
         padding-top: 0.5rem;
    font-size: 0.53rem;
    font-weight: bold;
    margin-bottom: 0.42rem;
}

.desc {
  // margin-bottom: 1.5rem;
  text-indent: 28px;
  font-size: 0.34rem;

  a {
    word-break: break-all;
  }
  &.last-child{
    margin-bottom: 0 !important;
  }
}
.form-check-label {
  margin-bottom: .5rem;
  position: relative;
  font-size: 0.35rem;
   display: flex;
    justify-content: start;
    align-items: flex-start;
        gap: 0.32rem;
   .check-box {
    // position: absolute;
    display: inline-block;
    width: .53rem;
    height: .53rem;
    // left: 0.1rem;
    line-height: .53rem;
    border-radius: 0.15rem;
    color: #ffffff;
    // top: 2px;
    font-size: .42rem;
    text-align: center;
    background-color: transparent;
    background-image: none;
    border: 1px solid #666666 ;
    &.active {
   
      background: rgb(16,142,233);
      border: 1px solid rgb(16,142,233);
    }
  }
  .check-label{
    flex: 1;
  }
}
.step-bar-bg{
    background: #F1F1F1 ;
    border-radius: 0.32rem;
    padding: 0.42rem;
    margin-bottom: 0.42rem;
    font-size: 0.34rem;

}
@media screen and (orientation: landscape) {
.btn-for-vertical{
  width: 60%;
  margin: 0 auto;
  padding-left: 0.6rem;
  padding-right:0.6rem;
  box-sizing: border-box;
  }
  .title {
         padding-top:0 !important;
 }
}
</style>